<div style="border: 1px solid black;">
<div class="modalHeaderBlack height35">
  <mat-grid-list cols="12" class="width100 mg-0" rowHeight="45px">
    <mat-grid-tile [colspan]="2" [rowspan]="1" class="header-grid-tile">
      <span class="modal-title" style="font-size: 12px; font-weight: 500">
        Add Waiting List</span
      >
    </mat-grid-tile>
    <mat-grid-tile [colspan]="4" [rowspan]="1" class="header-grid-tile">
      <mat-radio-group
        class="radio-color"
        [(ngModel)]="patientType"
        (change)="patientTypeChange($event.value)"
        [disabled]="isEdit"
      >
        <mat-radio-button value="new"  data-automation-attribute="radio-new" checked>
        <label style="color: white;">  {{ "AppointmentPage.new" | translate }} </label></mat-radio-button
        >
        <mat-radio-button
          value="registered"
          data-automation-attribute="radio-existing"
        >
        <label style="color: white;"> {{ "AppointmentPage.existing" | translate }}</label>
        </mat-radio-button>
      </mat-radio-group>
    </mat-grid-tile>

    <mat-grid-tile [colspan]="6" [rowspan]="1" class="grid-test-1">
      <div class="master-search" *ngIf="patientType == 'registered'">
        <mat-icon matTooltip="{{ 'RegistrationPage.searchBar' | translate }}"
          >search</mat-icon
        >
        <input
          type="text"
          (focus)="isVisible = true"
          (focusout)="isVisible = false"
          (keyup.enter)="searchByMRN($event)"
          [placeholder]="'RegistrationPage.searchBar' | translate"
        />
        <mat-icon
          matTooltip="{{ 'payerInfo.expand' | translate }}"
          [matMenuTriggerFor]="masterSearch"
          *ngIf="!isVisible"
          class="search-btn"
          >arrow_drop_down</mat-icon
        >
        <mat-icon
          matTooltip="{{ 'payerInfo.collapse' | translate }}"
          *ngIf="isVisible"
          class="search-btn"
          >arrow_drop_up</mat-icon
        >
      </div>
      <mat-menu
        class="menu-master"
        [overlapTrigger]="false"
        #masterSearch="matMenu"
        disabled
      >
        <div>
          <form
            #searchForm="ngForm"
            class="master-search-form"
            (ngSubmit)="setSearch(searchForm.value)"
            data-automation-attribute="form-search"
          >
            <div
              (click)="$event.stopPropagation()"
              *ngFor="let search of searchList; let p_index = index"
              class="search-content-row"
            >
              <div
                *ngFor="let control of search.controls; let c_index = index"
                class="search-col search-col-{{ control.column }}"
              >
                <mat-form-field
                  *ngIf="control.type == 'date'"
                  appearance="outline"
                >
                  <mat-label>{{ control.placeholder }}</mat-label>

                  <input
                    matInput
                    [matDatepicker]="picker"
                    placeholder="{{ control.placeholder }}"
                    [(ngModel)]="this[control.name]"
                    value="{{ control.value }}"
                    name="{{ control.name }}"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>

                <div *ngIf="error.isError" class="alert alert-danger">
                  {{ error.errorMessage }}
                </div>

                <mat-form-field
                  *ngIf="control.type == 'text'"
                  appearance="outline"
                >
                  <mat-label>{{ control.placeholder }}</mat-label>

                  <input
                    matInput
                    placeholder="{{ control.placeholder }}"
                    [(ngModel)]="this[control.name]"
                    name="{{ control.name }}"
                    value="{{ control.value }}"
                    pattern="[a-zA-Z0-9]+"
                  />
                </mat-form-field>

                <mat-form-field
                  *ngIf="control.type == 'number'"
                  appearance="outline"
                >
                  <mat-label>{{ control.placeholder }}</mat-label>

                  <input
                    type="text"
                    matInput
                    placeholder="{{ control.placeholder }}"
                    [(ngModel)]="this[control.name]"
                    name="{{ control.name }}"
                    value="{{ control.value }}"
                    pattern="[a-zA-Z0-9]+"
                  />
                </mat-form-field>

                <mat-form-field
                  *ngIf="control.type == 'select'"
                  appearance="outline"
                >
                  <mat-label>{{ control.placeholder }}</mat-label>

                  <mat-select
                    id="{{ control.name }}"
                    placeholder="{{ control.placeholder }}"
                    [(ngModel)]="this[control.name]"
                    name="{{ control.name }}"
                    (selectionChange)="
                      selectOnChange(control.name, $event.value)
                    "
                    value="{{ control.value }}"
                    (focus)="selectOnClick(control, p_index, c_index)"
                  >
                    <div *ngIf="[control.name] == 'unit'">
                      <mat-option
                        *ngFor="let option of control.options"
                        [value]="option.id"
                      >
                        {{ option.desc }}
                      </mat-option>
                    </div>
                    <div *ngIf="[control.name] != 'unit'">
                      <mat-option
                        *ngFor="let option of control.options"
                        [value]="option"
                      >
                        {{ option.desc }}
                      </mat-option>
                    </div>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="search-content-row">
              <div class="search-col search-col-12 right">
                <button
                  matTooltip="{{ 'RegistrationPage.searchBar' | translate }}"
                  type="submit"
                  class="btn-master-search"
                  data-automation-attribute="btn-search"
                  mat-button
                >
                  <mat-icon>search</mat-icon>
                </button>
                &nbsp;
                <button
                  matTooltip="{{ 'payerInfo.reset' | translate }}"
                  type="button"
                  class="btn-master-cancel"
                  mat-button
                  (click)="clearSearch()"
                >
                  <mat-icon>refresh</mat-icon>
                </button>
              </div>
            </div>
          </form>
        </div>
      </mat-menu>
    </mat-grid-tile>
  </mat-grid-list>
</div>



<div class="top-div-lg" style="padding: 10px; height: 550px; overflow: auto">



    <app-patient-search 
    class="mb-10" 
    [search]="searchCriteria" 
    [list]="patientList" 
      [refreshTime]="refreshTime" 
      [hideAfter]="hidePatientSearch" 
      (onActionClick)="patientOnSelect($event)"></app-patient-search>
    <div class="bodyCreatePasscode" data-automation-attribute="div-modal-body">
      <div class="patient-detail fixed-height" *ngIf="patientInfoDisplay">
        <div class="flex">
          <div class="col-8">
            <div *ngIf="patientInfoDisplay" style="display: flex;width :100vh">
              <img [style.width]="'20px'" [src]="patientImage ? patientImage : './assets/images/user.png'" />&nbsp;
              <label class="patient-name-label"> {{ patientInfoDisplay }}</label>
              <img
              class="user-img"
              [src]="
                isVip ? './assets/images/email-icons/vip-icon.png' : null
              "
              *ngIf="isVip"
              style="height: 25px;object-position: left;margin-left: 10px;"
            />
            </div>
          </div>
          <div class="col-4 right">
          </div>
        </div>
      </div>
    </div>
    <div class="patient-table" (scroll)="onTableScroll($event)" *ngIf="dataSource.data.length > 0">
        <table mat-table #table [dataSource]="dataSource" class="dataSourceTable mt-10"
          data-automation-attribute="table-patient-details">

          <ng-container matColumnDef="photo">
            <th mat-header-cell *matHeaderCellDef class="headerPhoto">
             
            </th>
            <td mat-cell *matCellDef="let element; let i = index" class="headerPhoto">
              <mat-radio-button value="1" (click)="radioClicked1(element); $event.stopPropagation()"
                data-automation-attribute="radio-record">

              </mat-radio-button>
            </td>
          </ng-container>
          <ng-container matColumnDef="MRN">
            <th mat-header-cell *matHeaderCellDef class="headerMRN">{{ "AppointmentPage.mrn" | translate }}</th>
            <td mat-cell *matCellDef="let element" class="headerMRN">
              {{ element.mrn }}
            </td>
          </ng-container>
          <ng-container matColumnDef="idtype">
            <th mat-header-cell *matHeaderCellDef class="headerNRIC">
              {{ "AppointmentPage.idType" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="headerNRIC">
              {{ element.primaryIdentifier?element.primaryIdentifier.display:"" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="idnumber">
            <th mat-header-cell *matHeaderCellDef class="headerID">
              {{ "AppointmentPage.docNo" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="headerID">
              {{ element.primaryIdentifier?element.primaryIdentifier.value:"" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="headerName">
              {{ "AppointmentPage.name" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="headerName">
              {{ element.name }}
              <img
        class="user-img"
        [src]="
          element.vip ? './assets/images/email-icons/vip-icon.png' : null
        "
        *ngIf="element.vip"
        style="height: 20px;margin-bottom: 5px;object-position:left;margin-left: 5px;"
      />

            </td>
          </ng-container>

          <ng-container matColumnDef="gender">
            <th mat-header-cell *matHeaderCellDef class="headerGender">
              {{ "AppointmentPage.gender" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="headerGender">
              {{ element.gender?element.gender.display:"" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="contact">
            <th mat-header-cell *matHeaderCellDef class="headerContact">
              {{ "AppointmentPage.phone" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="headerContact">
              {{ element.mobileNumber ?element.mobileNumber.mobileNumber:"" }}
            </td>
          </ng-container>
          <ng-container matColumnDef="dob">
            <th mat-header-cell *matHeaderCellDef class="headerDate">
              {{ "AppointmentPage.dob" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="headerDate">
              {{ element.birthDate | date }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true" class="tableHeader"
            data-automation-attribute="header-patient-details"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" class="tableRow"
            data-automation-attribute="row-patient-details"></tr>
        </table>
      </div>

  <div class="app-form">
    <form [formGroup]="appointmentForm" #patientRegForm="ngForm">
      <div class="d-flex">
        <div class="displayInline">
          <img
            class="user-img"
            src="assets/images/noavatar.png"
            alt="Patient"
            title="Patient"
          
            *ngIf="!imageUser"
            data-automation-attribute="imgDefaultUser"
          />
          <img
            class="user-img"
            [src]="imageUser"
            alt="User"
            title="Patient"
            *ngIf="imageUser"
          />
          <div class="middle"  *ngIf="!isEdit" (click)="!isEdit && selectFile()">
                      <div class="text">{{ "EncounterListPage.upload" | translate
                        }}</div>
                    </div>
          <input
            type="file"
            class="hide"
            id="fileAttachment"
            multiple="multiple"
            accept="application/Image"
            (change)="handleFileSelect($event)"
          />
        </div>

        <div class="first-two-grid">
          <mat-grid-list cols="12" rowHeight="65px">
            <mat-grid-tile [colspan]="4">
              <app-master-form-field
                [isRequired]="true"
                [label]="'RegistrationPage.primaryID' | translate"
                [masterName]="masterAPI.IDENTIFICATION_TYPE_MASTER"
                [formControlName]="'IdType'"
                [parentForm]="appointmentForm"
                [defaultValue]="primaryValue"
                (itemSelected)="primaryIdentificationOnChange($event)"
                [isSubmitted]="patientRegForm.submitted"
              >
              </app-master-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="4">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label
                  >{{ "RegistrationPage.primaryDocNo" | translate }}
                </mat-label>
                <input
                  matInput
                  formControlName="IdNumber"
                  maxlength="25"
                  [placeholder]="'RegistrationPage.primaryDocNo' | translate"
                  (keyup)="primaryNumberOnKeyUp($event.target.value)"
                  (focusout)="idFocusOut($event.target.value)"
                  [required]="true"
                  [readonly]="isDisabled"
              /></mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="4" *ngIf="showExpirDatePicker">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>{{
                  "RegistrationPage.expiryDate" | translate
                }}</mat-label>
                <input
                  matInput
                  formControlName="idExpiry"
                  [matDatepicker]="picker21"
                  [placeholder]="'RegistrationPage.expiryDate' | translate"
                  [min]="date"
                  [required]="true"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker21"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker21></mat-datepicker>
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list>

          <mat-grid-list cols="12" rowHeight="60px">
            <mat-grid-tile [colspan]="4">
              <app-master-form-field
                [isRequired]="true"
                [label]="'RegistrationPage.prefix' | translate"
                [masterName]="masterAPI.PREFIX_MASTER"
                [formControlName]="'Title'"
                [defaultValue]="prefixValue"
                [parentForm]="appointmentForm"
                (itemSelected)="getGender($event)"
                (autoLoadCompleted)="getGender($event)"
                [isSubmitted]="patientRegForm.submitted"
              >
              </app-master-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="4">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label
                  >{{ "RegistrationPage.name" | translate }}
                </mat-label>
                <input
                  matInput
                  oninput="this.value = this.value.toUpperCase()"
                  formControlName="FullName"
                  [placeholder]="'RegistrationPage.name' | translate"
                  [required]="true"
                  maxlength="100"
                  pattern="([a-zA-Z,./@#\s\-%_]+)"
                />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="4">
              <app-master-form-field
                [isRequired]="true"
                [label]="'RegistrationPage.gender' | translate"
                [masterName]="masterAPI.GENDER_MASTER"
                [formControlName]="'Gender'"
                [defaultValue]="genderValue"
                [parentForm]="appointmentForm"
                [isSubmitted]="patientRegForm.submitted"
              >
              </app-master-form-field>
            </mat-grid-tile>
          </mat-grid-list>
        </div>
      </div>
      <mat-grid-list cols="12" rowHeight="60px">
        <mat-grid-tile [colspan]="3">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ "RegistrationPage.dobForm" | translate }}</mat-label>
            <input
              matInput
              formControlName="DOB"
              [matDatepicker]="picker20"
              [placeholder]="'inventory.chooseaDate' | translate"
              [min]="mindate"
              [max]="date"
              [required]="true"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker20"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker20></mat-datepicker>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="3">
          <mat-checkbox class="margin" formControlName="realdob">
            {{ "RegistrationPage.realdob" | translate }}
          </mat-checkbox>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="3">
          <div class="patient-age">
            <div class="year">
              <input
                matInput
                attr.data-automation-attribute="txtpatientageYears"
                value="{{ patientAge?.years }}"
                readonly
              />
            </div>
            <div class="months">
              <input
                matInput
                attr.data-automation-attribute="txtpatientageMonths"
                value="{{ patientAge?.months }}"
                readonly
              />
            </div>
            <div class="day">{{ patientAge?.days }}</div>
          </div>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="3">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ "RegistrationPage.emailID" | translate }}</mat-label>
            <input
              matInput
              type="email"
              formControlName="Email"
              [placeholder]="'RegistrationPage.emailID' | translate"
              [required]="FormRequiredFelds.emailRequired"
            />
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>

      <mat-grid-list cols="12" rowHeight="60px">
        <mat-grid-tile [colspan]="3">
          <app-master-form-field
            [isRequired]="true"
            [label]="'EncounterPage.countryCode' | translate"
            [masterName]="masterAPI.COUNTRY_CODE_MASTER"
            [formControlName]="'countryCodemobile'"
            [defaultValue]="mobileCodeValue"
            [parentForm]="appointmentForm"
            [isSubmitted]="patientRegForm.submitted"
            (itemSelected)="setPatternToMobileNumber($event)"
          >
          </app-master-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="3">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{
              "RegistrationPage.handphoneNo" | translate
            }}</mat-label>
            <input
              type="tel"
              [required]="true"
              formControlName="HandPhoneNumber"
              matInput
              oninput="this.value=this.value.replace(/[^0-9/:]/g,'');"
              [placeholder]="'RegistrationPage.handphoneNo' | translate"
              [minlength]="mobileNoMin"
              [maxlength]="mobileNoMax"
            />
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="3">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{
              "RegistrationPage.officeContact" | translate
            }}</mat-label>
            <input
              type="tel"
              formControlName="OffciePhoneNumber"
              matInput
              maxlength="15"
              [placeholder]="'RegistrationPage.officeContact' | translate"
              [required]="FormRequiredFelds.officeRequired"
              [pattern]="'[0-9+-]*'"
            />
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="3">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{
              "RegistrationPage.localContact" | translate
            }}</mat-label>
            <input
              type="tel"
              formControlName="HomePhoneNumber"
              matInput
              [placeholder]="'RegistrationPage.localContact' | translate"
              maxlength="15"
              [required]="FormRequiredFelds.homeReqired"
              [pattern]="'[0-9+-]*'"
            />
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>
      <mat-grid-list cols="12" rowHeight="60px">
        <mat-grid-tile [colspan]="12">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{
              "RegistrationPage.permanentAddress" | translate
            }}</mat-label>
            <input
              matInput
              formControlName="addressPrimary"
              maxlength="100"
              [placeholder]="'RegistrationPage.permanentAddress' | translate"
              attr.data-automation-attribute="txtAddress"
              pattern="^[\s\S]+$"
            />
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>
      <mat-grid-list cols="15" rowHeight="60px">
        <mat-grid-tile [colspan]="3">
          <app-master-form-field
            [isRequired]="false"
            [label]="'RegistrationPage.country' | translate"
            [masterName]="masterAPI.COUNTRY_MASTER"
            [formControlName]="'countryPrimary'"
            [parentForm]="appointmentForm"
            [defaultValue]="countryValue"
            (itemSelected)="getStatePrimaryList($event, false)"
            [isSubmitted]="patientRegForm.submitted"
          >
          </app-master-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="3">
          <app-master-form-field
            [isRequired]="false"
            [label]="'RegistrationPage.state' | translate"
            [masterName]="masterAPI.STATE_MASTER_QUERY"
            [formControlName]="'statePrimary'"
            [parentForm]="appointmentForm"
            [params]="CountryCode"
            [defaultValue]="stateValue"
            (itemSelected)="getCityPrimaryList($event)"
            [isSubmitted]="patientRegForm.submitted"
          >
          </app-master-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="3">
          <app-master-form-field
            [isRequired]="false"
            [label]="'RegistrationPage.city' | translate"
            [masterName]="masterAPI.CITY_MASTER_QUERY"
            [formControlName]="'cityPrimary'"
            [defaultValue]="cityValue"
            [parentForm]="appointmentForm"
            [params]="StateCode"
            (itemSelected)="getSubDistrictPrimaryList($event)"
            [isSubmitted]="patientRegForm.submitted"
          >
          </app-master-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="3">
          <app-master-form-field
            [isRequired]="false"
            [label]="'RegistrationPage.subDistrict' | translate"
            [masterName]="masterAPI.DIST_MASTER_QUERY"
            [formControlName]="'subDistrictPrimary'"
            [defaultValue]="districtValue"
            [parentForm]="appointmentForm"
            [params]="CityCode"
            [isSubmitted]="patientRegForm.submitted"
          >
          </app-master-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="3">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{ "RegistrationPage.zipcode" | translate }}</mat-label>
            <input
              matInput
              type="text"
              formControlName="pincodePrimary"
              numberOnly
              maxlength="10"
              class="example-right-align"
              [placeholder]="'RegistrationPage.zipcode' | translate"
              attr.data-automation-attribute="txtPincode"
              pattern="[a-zA-Z0-9]+"
            />
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>
    </form>
    <mat-grid-list cols="12" rowHeight="60px">
      <mat-grid-tile [colspan]="3">
        <mat-form-field appearance="outline">
          <mat-label>
            {{ "AppointmentPage.appointmenttype" | translate }}
          </mat-label>
          <mat-select
          required
            [formControl]="appointmentTypeCtrl"
            [(ngModel)]="appointmentType"
            [placeholder]="'AppointmentPage.appointmenttype' | translate"
            data-automation-attribute="select-appointment-type"
            (selectionChange)="onAppointmentChange($event.value)"
            #appointmentTypeSelect
          >
            <mat-option
              *ngFor="let option of filteredappointmentType | async"
              [value]="option.code"
            >
              {{ option.desc }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="3">
        <mat-form-field appearance="outline">
          <mat-label>
            Speciality
          </mat-label>
       
          <mat-select
          required
            [formControl]="deptCtrl"
            [(ngModel)]="department"
            [placeholder]="'AppointmentPage.doctordepartment' | translate"
            data-automation-attribute="select-appointment-type"
            #deptTypeSelect
            (selectionChange)="getDoctorList($event.value)"
          >
            <mat-option>
              <ngx-mat-select-search
                [formControl]="deptFilterCtrl"
                class="full-width"
                ngDefaultControl
                [placeholderLabel]="'RegistrationPage.search' | translate"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option
              *ngFor="let option of filteredDepts"
              [value]="option.code"
            >
              {{ option.desc }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="3">
        <mat-form-field appearance="outline">
          <mat-label>{{
            "AppointmentPage.consultationtype" | translate
          }}</mat-label>
          <mat-select [(ngModel)]="teleconsultaion" required [formControl]="teleconsultaionCtrl">
            <mat-option
              *ngFor="let option of filteredTelecom | async"
              [value]="option.code"
            >
              {{ option.desc }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="3">
        <mat-form-field class="full-width" appearance="outline" *ngIf="appointmentType=='1'">
          <mat-label>{{ "EncounterPage.doctor" | translate }}</mat-label>
          <mat-select required [formControl]="doctorCtrl"
          [(ngModel)]="selectedDoctorCode">
            <mat-option>
              <ngx-mat-select-search
                [formControl]="docFilterCtrl"
                class="full-width"
                ngDefaultControl
                [placeholderLabel]="'RegistrationPage.search' | translate"
              ></ngx-mat-select-search>
             </mat-option>
            <mat-option>{{ "RegistrationPage.none" | translate }}</mat-option>
            <mat-option
              *ngFor="let option of doctorFilteredList"
              [value]="option.code"
            >
              {{ option.desc }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>

    <mat-grid-list cols="12" rowHeight="60px">
      <mat-grid-tile [colspan]="3">
        <mat-form-field appearance="outline">
          <mat-label>Visit Type </mat-label>
          <mat-select  [(ngModel)]="visitType">
            <mat-option>{{ "RegistrationPage.none" | translate }}</mat-option>
            <mat-option
            *ngFor="let option of visitTypeList"
            [value]="option.code"
          >
            {{ option.desc }}
          </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2">
        <label [class.red]="isDatePreferanceReq">Date Preferance</label> &nbsp;<label for="*" class="red">*</label>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="4">
        <mat-radio-group
          [(ngModel)]="datePreferance"
          (change)="datePreferanceChange($event)"
        >
          <mat-radio-button [class.red]="isDatePreferanceReq"
            value="speDate"
            data-automation-attribute="radio-new"
          >
            Specific Date(s)
          </mat-radio-button>
          <mat-radio-button [class.red]="isDatePreferanceReq"
            value="period"
            data-automation-attribute="radio-existing"
          >
            Period
          </mat-radio-button>
        </mat-radio-group>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="3">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Time Preferance</mat-label>
          <mat-select [(ngModel)]="timePreferance" (selection)="timePreferanceChange($event.value)">
            <mat-option value="anyTime">Any Time</mat-option>
            <mat-option value="timePeriod">Time Period</mat-option>
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>

<div style="display: flex; justify-self: right;">
    <div style="width: 250px;align-content: center;">
        <div *ngIf="datePreferance === 'speDate'">
     
            <!-- Option 1 Date Picker -->
            <mat-form-field appearance="outline" style="width: 160px">
              <mat-label>Option 1</mat-label>
              <input matInput [matDatepicker]="picker1" [formControl]="option1Ctrl" [min]="todaysDate" />
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
            
            <mat-form-field appearance="outline" style="width: 160px">
              <mat-label>Option 2</mat-label>
              <input matInput [matDatepicker]="picker2" [formControl]="option2Ctrl" [min]="todaysDate" />
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
            
            <mat-form-field appearance="outline" style="width: 160px">
              <mat-label>Option 3</mat-label>
              <input matInput [matDatepicker]="picker3" [formControl]="option3Ctrl" [min]="todaysDate" />
              <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
              <mat-datepicker #picker3></mat-datepicker>
            </mat-form-field>
            
          
        </div>
        <div *ngIf="datePreferance === 'period' ">
            
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <mat-label>From</mat-label> <label for="*" class="red">*</label>
            <mat-form-field appearance="outline" style="width: 160px">
              <input matInput [matDatepicker]="picker4" [formControl]="periodFromDateCtrl" [min]="todaysDate" readonly required/>
              <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
              <mat-datepicker #picker4></mat-datepicker>
            </mat-form-field>
          </div>
          
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <mat-label>To</mat-label><label for="*" class="red">*</label>
            <mat-form-field appearance="outline" style="width: 160px">
              <input matInput [matDatepicker]="picker5" [formControl]="periodToDateCtrl" [min]="minToDate"  readonly  required/>
              <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
              <mat-datepicker #picker5></mat-datepicker>
            </mat-form-field>
          </div>
          
          
        </div>
    </div>
    <div style="width: 250px;">
        <div *ngIf="timePreferance === 'timePeriod'">
            <div style="display: flex; justify-content: space-between;">
            <label style="align-content: center;">From Time</label>
            <mat-form-field appearance="outline" style="width: 160px">
                <input matInput type="time" />
              </mat-form-field>
            </div>
            <div style="display: flex; justify-content: space-between;">
              <label style="align-content: center;">To Time</label>
              <mat-form-field appearance="outline" style="width: 160px">
                <input matInput type="time" />
              </mat-form-field>
            </div>
        </div>
    </div>
</div>

   

   


    <mat-grid-list cols="12" rowHeight="60px">
      <mat-grid-tile [colspan]="12">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Remark</mat-label>
          <input
            matInput
            [(ngModel)]="remark"
            maxlength="100"
            [placeholder]="'RegistrationPage.remarks' | translate"
            attr.data-automation-attribute="txtRemarks"
            pattern="^[\s\S]+$"
          />
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
</div>
<div style="padding: 10px; background: #e8e8e8">
  <mat-grid-list cols="12" rowHeight="40px">
    <mat-grid-tile [colspan]="11"></mat-grid-tile>
    <mat-grid-tile [colspan]="1">
      <button
        matTooltip="Back"
        class="btnOrange"
        mat-mini-fab
        (click)="closeDialog()"
        data-automation-attribute="btn-save"
      >
        <mat-icon>arrow_back_ios</mat-icon></button
      >&nbsp;&nbsp;
      <button
        matTooltip="{{ 'payerInfo.save' | translate }}"
        class="btnCyan"
        (click)="validationOnSave()"
        mat-mini-fab
        data-automation-attribute="btn-save"
        type="submit"
      >
        <mat-icon>sim_card</mat-icon>
      </button>
    </mat-grid-tile>
  </mat-grid-list>
</div>
    
</div>